import { Button, Popup } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { IState } from 'reducers/reducers';
import { Content } from '@visikon/core-models';
import { langFromCode } from 'commons/languages';
import { useGenerateModulePreview } from 'api/programsApi';
import { API } from 'config';

function getModulePreviewUrl(id: string, language: Content.LanguageCode, livePath?: string, previewPath?: string) {
  const search = new URLSearchParams({ reviewer: 'true' });
  if (livePath) search.set('live_path', livePath);
  if (previewPath) search.set('preview_path', previewPath);

  return `${API.baseModulePreviewUrl}/${id}/${language}?${search.toString()}`;
}

interface ModulePreviewButtonProps {
  id: string;
  revisions?: Content.PublishedRevisions;
}

export function ModulePreviewButton({ id, revisions }: ModulePreviewButtonProps) {
  const { isLoading, mutateAsync, isError, error } = useGenerateModulePreview(id);
  const languageCode = useSelector((state: IState) => state.language.activeLanguage);
  const language_info = langFromCode(languageCode);

  const onClick = async () => {
    const res = await mutateAsync();

    const previewUrl = getModulePreviewUrl(id, languageCode, revisions?.live?.path, res.filePath);
    window.open(previewUrl, '_blank');
  };

  return (
    <Popup
      className="negative"
      open={isError}
      position="bottom right"
      content={`Failed to generate preview! Reason:\n\n\n\n${error?.message ?? 'Unknown Error'}`}
      trigger={
        <Button disabled={isLoading} loading={isLoading} onClick={onClick}>
          <i className={`${language_info.flag} flag`} style={{ visibility: isLoading ? 'hidden' : 'visible' }} />
          Preview
        </Button>
      }
    />
  );
}
